import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getConsolidatedData,
  getConsolidatedManPower,
} from "../../services/MapApi.tsx";
import {
  getDataWithKeyValue,
  getRequestParams,
  sortListItems,
} from "../../utils/Util.tsx";
import { getCombinedBusinessHeaders } from "../../utils/TableHeaders.tsx";
import TableComponent from "../../components/UI/TableComponent.tsx";
import {
  ALL_PRODUCT,
  COUNTRY,
  DATE_FORMAT,
  TABLE_SORT_ASC,
} from "../../utils/Constants.tsx";
import moment from "moment";
import KshemaLoader from "../../components/UI/KshemaLoader.tsx";
import { OptionType } from "../../utils/Types.tsx";
const ConsolidatedView = ({ selectedFilters, setSelectedRow }) => {
  const dispatch: any = useDispatch();
  const { stateViewData } = useSelector((state: any) => state.map);
  const [stateTableData, setStateTableData] = useState([]);
  const [columnHeaders, setColumnHeaders] = useState([]);
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [column, setColumn] = useState("");
  const statesWithId = useSelector(
    (state: any) => state?.filter?.statesDataWithId
  );
  const districtsWithId = useSelector(
    (state: any) => state?.filter?.districtsDataWithId
  );
  const [selectedState, setSelectedState] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const productListWithId = useSelector(
    (state: any) => state?.filter?.products
  );
  
  useEffect(() => {
    // Check if stateViewData is available before proceeding
    if (stateViewData) {
      // Update the state with the transformed table data
      const rawData = stateViewData?.data;
      const viewData: any = [];
      rawData?.forEach((element: any) => {
        if (element?.vstate) {
          viewData.push(element);
        }
      });
       if (viewData?.length > 1) {
        const total = stateViewData?.totals;
        viewData.push({
          total_policies: total?.total_policies,
          total_premium: total?.total_premium,
          total_suminsured: total?.total_suminsured,
          accepted_policies: total?.accepted_policies,
          accepted_premium: total?.accepted_premium,
          accepted_suminsured: total?.accepted_suminsured,
          claim_calculated: total?.claim_calculated,
          loss_ratio: total?.loss_ratio,
          previous_season_loss_ratio: total?.previous_season_loss_ratio,
          total_claims: total?.total_claims,
          total_claim_amount: total?.total_claim_amount,
          vstate: "Total",
          vdistrict: "Total",
          gridid: "Total",
          proposer_name:"Total"
        });
      }
      setStateTableData(viewData || []);

      // Check if all items belong to the same district
      const districtWiseData = stateViewData?.data?.every(
        (item) => item.vdistrict === stateViewData?.data?.[0]?.vdistrict
      );

      // Set column headers based on the data's district consistency
      if (stateViewData?.isPosp)
        setColumnHeaders(getCombinedBusinessHeaders("POSP"));
      else if (districtWiseData) {
        setColumnHeaders(getCombinedBusinessHeaders("grid"));
      } else if (column === "district") {
        setColumnHeaders(getCombinedBusinessHeaders("district"));
      } else {
        setColumnHeaders(getCombinedBusinessHeaders("state"));
      }

      // Mark loading as complete
      setIsLoading(false);
    }
  }, [stateViewData]);

  const onFilterUpdate = () => {
    setColumn("");
    setIsLoading(true); // Start loading indicator

    // Initialize variables to hold selected filter values
    let selectedState: any = null;
    let selectedDistrict: any = null;
    let selectedProduct: any = null;
    const seasonArray: string[] = [];

    // Handle selected state
    if (selectedFilters?.state) {
      selectedState =
        selectedFilters?.state === COUNTRY
          ? selectedFilters?.state // If country-level selected
          : getDataWithKeyValue(statesWithId, "vstate", selectedFilters?.state); // Match state from list

      if (selectedFilters?.state !== COUNTRY) setColumn("district"); // Update column view to district level
    }
    setSelectedState(selectedState); // Store selected state

    // Handle selected district
    if (selectedFilters?.district) {
      selectedDistrict = getDataWithKeyValue(
        districtsWithId,
        "vdistrict",
        selectedFilters?.district
      );
    }
    setSelectedDistrict(selectedDistrict);
    if (selectedFilters?.product && selectedFilters?.product === ALL_PRODUCT) {
      selectedProduct = {
        productid: "",
        productname: "",
      };
    } else if (selectedFilters?.product) {
      // Match product from list
      selectedProduct = getDataWithKeyValue(
        productListWithId,
        "productname",
        selectedFilters?.product
      );
    }
    setSelectedProduct(selectedProduct);

    if (selectedFilters?.season && selectedFilters?.season?.length > 0) {
      selectedFilters?.season?.forEach((item: OptionType) => {
        seasonArray.push(item?.value);
      });
    }

    if (selectedFilters?.levelOne === "Consolidated Manpower") {
      // Dispatch API call with constructed parameters
      dispatch(
        getConsolidatedManPower(
          getRequestParams(
            selectedFilters,
            selectedProduct.productid,
            seasonArray,
            selectedFilters?.year,
            selectedState?.sid,
            selectedDistrict?.did,
            selectedFilters?.gridId
          )
        )
      );
    } else {
      // Dispatch API call with constructed parameters
      dispatch(
        getConsolidatedData(
          getRequestParams(
            selectedFilters,
            selectedProduct.productid,
            seasonArray,
            selectedFilters?.year,
            selectedState?.sid,
            selectedDistrict?.did,
            selectedFilters?.gridId
          )
        )
      );
    }
  };

  useEffect(() => {
    if (
      selectedFilters?.levelOne == "Consolidated Business" ||
      selectedFilters?.levelOne == "Consolidated Manpower"
    ) {
      onFilterUpdate();
    }
  }, [selectedFilters]);

  const getItemWiseData = (row, headerItem) => {
    setIsLoading(true); // Start loading indicator

    // Check if all items in the table belong to the same state
    // const districtWiseData = stateTableData.every(
    //   (item) => item.vstate === row.vstate
    // );
    // let paramDid: string = "";
    // if (districtWiseData) {
    //   // If all items are from the same state, include district ID
    //   paramDid = row?.did;
    //   setSelectedRow(row);
    //   setColumn(""); // Clear column view (likely to show detailed view)
    // } else {
    //   // If items span multiple states, set column view to district level
    //   setColumn("district");
    //   setSelectedRow(row);
    // }

    setColumn("district");
    setSelectedRow(row);
    const params = getRequestParams(
      selectedFilters,
      selectedProduct?.productid,
      selectedFilters?.season?.length > 0 ? [selectedFilters.season] : null,
      selectedFilters?.year,
      row?.sid,
      row?.did,
      selectedFilters?.gridId
    );
    params.sid = row?.sid;
    if (headerItem?.field === "vdistrict") {
      params.did = row?.did;
    }
    dispatch(getConsolidatedData(params));
    // Update column headers to reflect district-level view
    setColumnHeaders(getCombinedBusinessHeaders("district"));

    // Set default sort order for the table
    setSortOrder(TABLE_SORT_ASC);
  };

  const sortTableItems = (sortBy, sortOrder) => {
    setStateTableData(sortListItems(stateTableData, sortBy, sortOrder));
  };

  return (
    <>
      {!isLoading && stateTableData && stateTableData.length ? (
        <TableComponent
          data={stateTableData}
          columnHeaders={columnHeaders}
          onAction={(rowItem, headerItem) => {
            getItemWiseData(rowItem, headerItem);
          }}
          handleSort={sortTableItems}
          sortBy={sortBy}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          setSortBy={setSortBy}
          filterName=""
        />
      ) : (
        ""
      )}
      {!isLoading && stateTableData && stateTableData?.length === 0 && (
        <div className="d-flex justify-content-center">
          <> There is no {selectedFilters?.levelOne}</>
        </div>
      )}
      {isLoading && (
        <div>
          <KshemaLoader />
        </div>
      )}
    </>
  );
};
export default ConsolidatedView;
